module.exports = __webpack_public_path__ + "static/media/tel.d1dd6b52.svg";